// extracted by mini-css-extract-plugin
module.exports = {"greeting":"DashboardGreeting_greeting__3nzVd","title":"DashboardGreeting_title__2O5nb","info":"DashboardGreeting_info__2_IST","navigation":"DashboardGreeting_navigation__2XPdJ"};